import { openBlock as l, createElementBlock as n, normalizeClass as r, createElementVNode as s, renderSlot as t, createTextVNode as a } from "vue";
/* empty css                    */
import i from "./design-system.es128.js";
const c = {
  name: "DsModalHeader",
  props: {
    /**
     * Use sticky header on desktop as well as mobile
     */
    sticky: Boolean,
    /**
     * Use fullscreen header
     */
    fullscreen: Boolean
  }
}, m = { class: "modal-header-leading" }, f = { class: "modal-header-main" }, u = { class: "modal-header-trailing" };
function p(o, e, d, _, k, v) {
  return l(), n("div", {
    class: r(["modal-header", { sticky: d.sticky, fullscreen: d.fullscreen }])
  }, [
    s("div", m, [
      t(o.$slots, "leading", {}, void 0, !0)
    ]),
    e[0] || (e[0] = a()),
    s("div", f, [
      t(o.$slots, "title", {}, void 0, !0)
    ]),
    e[1] || (e[1] = a()),
    s("div", u, [
      t(o.$slots, "trailing", {}, void 0, !0)
    ])
  ], 2);
}
const B = /* @__PURE__ */ i(c, [["render", p], ["__scopeId", "data-v-ab36cb9f"]]);
export {
  B as default
};
//# sourceMappingURL=design-system.es17.js.map
